<template>
  <QBtn v-bind="$attrs">
    <slot>
      <span :style="{ opacity }">
        <i
          class="far fa-smile q-px-xs"
          style="font-size: 1.2em"
        />&nbsp;+
      </span>
    </slot>
    <QMenu
      ref="menu"
      anchor="top left"
      self="top left"
      class="overflow-hidden"
      style="width: 250px;"
    >
      <EmojiPickerInner
        :clearable="clearable"
        :exclude="exclude"
        :selected="selected"
        @select="(...args) => emit('select', ...args)"
        @clear="emit('clear')"
      />
    </QMenu>
  </QBtn>
</template>

<script setup>
import {
  QBtn,
  QMenu,
} from 'quasar'
import { defineAsyncComponent, useTemplateRef } from 'vue'

const EmojiPickerInner = defineAsyncComponent(() => import('./EmojiPickerInner.vue'))

const menu = useTemplateRef('menu')

defineExpose({
  show () {
    menu.value?.show()
  },
  hide () {
    menu.value?.hide()
  },
})

defineProps({
  opacity: {
    type: Number,
    default: 1,
  },
  exclude: {
    type: Array,
    default: () => [],
  },
  selected: {
    type: String,
    default: null,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits([
  'select',
  'clear',
])
</script>
